import type { DisplayState, Strings } from "../state.js";
import { Header } from "./Header.js";
import { Footer } from "./Footer.js";
import { Orb } from "./Orb.js";
import { TextInput } from "./TextInput.js";
import { Transcript } from "./Transcript.js";
import type { TranscriptMessage } from "../types.js";
import type { ResolvedOrbPalette } from "../orbPalette.js";

export interface PanelProps {
  displayState: DisplayState;
  strings: Strings;
  active: boolean;
  muted: boolean;
  muteButton?: boolean;
  showTranscript?: boolean;
  textInput?: boolean;
  transcript: readonly TranscriptMessage[];
  palette?: ResolvedOrbPalette;
  onStart(): void;
  onStop(): void;
  onToggleMute(): void;
  onSendText(text: string): void | Promise<void>;
}

export function Panel(props: PanelProps) {
  const {
    displayState,
    strings,
    active,
    muted,
    muteButton,
    showTranscript,
    textInput,
    transcript,
    palette,
    onStart,
    onStop,
    onToggleMute,
    onSendText,
  } = props;
  // Non-modal, persistent widget: a labelled region rather than a dialog, so screen
  // readers don't announce a modal/focus-trap that doesn't exist.
  return (
    <div class="va-panel" role="region" aria-label={strings.panelLabel}>
      <Header
        displayState={displayState}
        strings={strings}
        showOrb={showTranscript}
        palette={palette}
      />
      {!showTranscript ? (
        <div class="va-body">
          <Orb displayState={displayState} palette={palette} />
        </div>
      ) : null}
      {showTranscript ? <Transcript messages={transcript} strings={strings} /> : null}
      {textInput ? (
        <TextInput
          enabled={active && displayState !== "connecting"}
          strings={strings}
          onSend={onSendText}
        />
      ) : null}
      <Footer
        active={active}
        muted={muted}
        muteButton={muteButton}
        strings={strings}
        onStart={onStart}
        onStop={onStop}
        onToggleMute={onToggleMute}
      />
    </div>
  );
}
